// import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { useNavigate } from "react-router-dom";

// const Header = () => {
//   const navigate = useNavigate();
//   return (
//     <Navbar
//       expand="lg"
//       style={{ background: "rgba(21, 21, 21, 1)", padding: "15px 0px" ,  zIndex:1}}
//     >
//       <Container fluid>
//         <Navbar.Brand style={{ paddingLeft: 50 ,cursor:"pointer"}}   onClick={() => {
//                 navigate("/");
//               }}> 
//           <img src="../images/Group.png" style={{ height: "30px" }}></img>
//         </Navbar.Brand>
//         <Navbar.Toggle aria />
//         <Navbar.Collapse
//           id="navbarScroll"
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             alignItems: "center",
//           }}
//         >
//           <Nav
//             className=" my-2 my-lg-0"
//             navbarScroll
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <Nav.Link
//               style={{ padding: "0px 50 px", color: "white", fontSize: "18px" }}
//               onClick={() => {
//                 navigate("/");
//               }}
//             >
//               Home
//             </Nav.Link>
//             <Nav.Link
//               style={{ padding: "0px 50px", color: "white", fontSize: "18px" }}
//               onClick={() => {
//                 navigate("/mission");
//               }}
//             >
//               Mission
//             </Nav.Link>
//             <Nav.Link
//               style={{ padding: "0px 50px", color: "white", fontSize: "18px" }}
//               onClick={() => {
//                 navigate("/contact");
//               }}
//             >
//               Contact
//             </Nav.Link>
//             <div style={{ paddingRight: 22,cursor:"pointer" }}   onClick={() => {
//                 navigate("/");
//               }}>
//               <img src="../images/Vector.png" style={{ height: "30px" }}></img>
//             </div>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// export default Header;

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";


export default function Header(props) {
 
  const navigate = useNavigate();

    return (
      <nav class="navbar navbar-expand-lg "  style={{ background: "rgba(21, 21, 21, 1)", padding: "13px 0px" ,  zIndex:1}}>
      <Navbar.Brand style={{ paddingLeft: 50 ,cursor:"pointer"}}   onClick={() => {
                navigate("/");
              }}> 
          <img src="../images/Group.png" style={{ height: "30px" }}></img>
        </Navbar.Brand>
     
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"  style={{background:"white",marginRight:22}} aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto" >
          <li class="nav-item active">
          <Nav.Link
          style={{ margin: "5px 50px", color: "white", fontSize: "18px",padding:"0px" }}
             className="navText"
              onClick={() => {
                navigate("/");
              }}
            >
               <h6 class="fromLeft">  Home</h6>
            </Nav.Link>
          </li>
          <li class="nav-item">
          <Nav.Link
           style={{ margin: "5px 50px", color: "white", fontSize: "18px",padding:"0px" }}
              
              onClick={() => {
                navigate("/story");
              }}
            >
              <h6 class="fromLeft">  Story</h6>
            </Nav.Link>
          </li>
          <li class="nav-item">
          <Nav.Link
              style={{ margin: "5px 50px", color: "white", fontSize: "18px",padding:"0px" }}
              onClick={() => {
                navigate("/contact");
              }}
            >
                <h6 class="fromLeft">  Contact</h6>
            </Nav.Link>
          </li>
          <li class="nav-item">
          <div style={{ 
            padding: "5px 28px 5px 50px",cursor:"pointer" 
        }}   onClick={() => {
                navigate("/");
              }}>
              <img src="../images/Vector.png" style={{ height: "30px" }}></img>
            </div>
          </li>
          
          
        </ul>
        
      </div>
    </nav>
    )
}
